<div class="video-records">
  <div class="item" *ngFor="let item of video; trackBy: trackById">
    <div class="video" [mtgHeightRatio]="1.77">
      <iframe
        [src]="item.videoUrl | safe: 'resourceUrl'"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</div>
